/**
 * DropdownContext - Ensures only one dropdown/modal is open at a time
 */

import { createContext, useContext, useState, ReactNode } from 'react';

type DropdownType = 'notification' | 'profile' | null;

interface DropdownContextType {
  activeDropdown: DropdownType;
  setActiveDropdown: (dropdown: DropdownType) => void;
  closeAll: () => void;
}

const DropdownContext = createContext<DropdownContextType | undefined>(undefined);

export function DropdownProvider({ children }: { children: ReactNode }) {
  const [activeDropdown, setActiveDropdown] = useState<DropdownType>(null);

  const closeAll = () => setActiveDropdown(null);

  return (
    <DropdownContext.Provider value={{ activeDropdown, setActiveDropdown, closeAll }}>
      {children}
    </DropdownContext.Provider>
  );
}

export function useDropdown() {
  const context = useContext(DropdownContext);
  if (!context) {
    throw new Error('useDropdown must be used within a DropdownProvider');
  }
  return context;
}
